import {healthcheckService} from "./services/healthcheck";
import dayjs from 'dayjs';

export const TjMixin = {
  methods: {
    /**
     * 查看按钮
     * @param data
     * @returns {boolean}
     */
    showChakan(data) {
      return ['ALREADY_CHECK', 'FINSH'].includes(data.orderStatus);
    },
    showYuyue(data) {
      return ['WAIT_HANDLE', 'OVERDUE'].includes(data.orderStatus);
    },
    showGenggai(data) {
      return ['WAIT_CHECK'].includes(data.orderStatus);
    },
    orderCancel(data) {
      this.$confirm('是否取消 ' + data.healthcheckerName + ' ' + (data.appointmentTime || '') + ' 的预约？')
        .then(async () => {
          if (await healthcheckService.tjOrderCancel(data.id, '团队管理员取消')) {
            location.reload();
          }
        })
        .catch(() => {
          Log('no');
        })
    }
  },
}

export const RiliMixin = {
  data() {
    return {
      curr: new Date(),
    }
  },
  computed: {
    week() {
      return ['日', '一', '二', '三', '四', '五', '六']
    },
    currYear() {
      const {curr} = this;
      return dayjs(curr).year();
    },
    currMonth() {
      const {curr} = this;
      return dayjs(curr).format('MM');
    },
    first() {
      const {curr} = this;
      return dayjs(curr).startOf('month')
    },
    start() {
      const {first} = this;
      const day = dayjs(first).day();
      return dayjs(first).subtract(day, 'day');
    },
    last() {
      const {curr} = this;
      return dayjs(curr).endOf('month');
    },
    end() {
      const {last} = this;
      const day = dayjs(last).day();
      return dayjs(last).add(6 - day, 'day');
    },
  },
  methods: {
    handlerRili(type) {
      if (type === '+') {
        this.curr = dayjs(this.end).add(1, 'day');
      } else if (type === '-') {
        this.curr = dayjs(this.start).subtract(1, 'day');
      } else {
        this.curr = dayjs();
      }
    }
  },
}
